export default "__VITE_ASSET__Dn7mv3hy__"